import ApiService from '@/core/services/api.service';
import { handleApiError, handleApiSuccess } from '@/utils/errorHandler';

const state = {
  categories: [],
  parentCategories: [],
  loading: false,
  error: null,
  totalRows: 0,
};

const mutations = {
  SET_CATEGORIES(state, categories) {
    state.categories = categories;
  },
  SET_PARENT_CATEGORIES(state, categories) {
    state.parentCategories = categories;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_TOTAL_ROWS(state, total) {
    state.totalRows = total;
  },
};

const actions = {
  async fetchCategories({ commit }, params) {
    commit('SET_LOADING', true);
    try {
      const { data } = await ApiService.query('transactionCategory', {
        params,
      });
      const result = handleApiSuccess(data);
      if (result.success) {
        commit('SET_CATEGORIES', result.data.list_caterogy);
        commit('SET_TOTAL_ROWS', result.data.total_row);
        return result;
      } else {
        commit('SET_ERROR', result.message);
        return result;
      }
    } catch (error) {
      const errorMessage = handleApiError(error);
      commit('SET_ERROR', errorMessage);
      return { success: false, message: errorMessage };
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchParentCategories({ commit }) {
    commit('SET_LOADING', true);
    try {
      const { data } = await ApiService.query('transactionCategory', {
        params: { name: '', code: '' },
      });
      const result = handleApiSuccess(data);
      if (result.success) {
        commit('SET_PARENT_CATEGORIES', result.data.list_caterogy);
        return result;
      } else {
        commit('SET_ERROR', result.message);
        return result;
      }
    } catch (error) {
      const errorMessage = handleApiError(error);
      commit('SET_ERROR', errorMessage);
      return { success: false, message: errorMessage };
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async createCategory({ commit, dispatch }, formData) {
    commit('SET_LOADING', true);
    try {
      const { data } = await ApiService.post(
        'transactionCategory/create',
        formData,
      );
      const result = handleApiSuccess(data);
      commit('SET_LOADING', false);
      if (result.success) {
        await dispatch('fetchCategories');
        await dispatch('fetchParentCategories');
      }
      return result;
    } catch (error) {
      const errorMessage = handleApiError(error);
      return { success: false, message: errorMessage };
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async updateCategory({ dispatch, commit }, formData) {
    commit('SET_LOADING', true);
    try {
      const { data } = await ApiService.post(
        'transactionCategory/update',
        formData,
      );
      const result = handleApiSuccess(data);
      if (result.success) {
        await dispatch('fetchCategories');
        await dispatch('fetchParentCategories');
      }
      commit('SET_LOADING', false);

      return result;
    } catch (error) {
      const errorMessage = handleApiError(error);
      return { success: false, message: errorMessage };
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async deleteCategory({ dispatch }, id) {
    try {
      const { data } = await ApiService.post(
        `transactionCategory/delete/${id}`,
      );
      const result = handleApiSuccess(data);
      if (result.success) {
        await dispatch('fetchCategories');
        await dispatch('fetchParentCategories');
      }
      return result;
    } catch (error) {
      const errorMessage = handleApiError(error);
      return { success: false, message: errorMessage };
    }
  },

  async getCategoryById({ commit }, id) {
    try {
      const { data } = await ApiService.get(`transactionCategory/${id}`);
      const result = handleApiSuccess(data);
      if (!result.success) {
        commit('SET_ERROR', result.message);
      }
      return result;
    } catch (error) {
      const errorMessage = handleApiError(error);
      commit('SET_ERROR', errorMessage);
      return { success: false, message: errorMessage };
    }
  },
};

const getters = {
  categories: (state) => state.categories,
  parentCategories: (state) => state.parentCategories,
  
  loading: (state) => state.loading,
  error: (state) => state.error,
  totalRows: (state) => state.totalRows,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
